import React, { useState, useEffect } from "react";
import { fetchPotentialProjectFlags, FlagsStore, deletePotentialProjectFlag } from "./store";
import { format } from "date-fns";
import debounce from "debounce";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";

import usePagination from "../../hooks/usePagination";
import Pagination from "$components/table/components/pagination";
import Table from "$components/table/index.js";

import { LONG_DATE_FORMAT } from "$utils/date-helpers.js";

const flagColumns = [
    {
        Header: () => "Id",
        accessorKey: "id", // accessor is the "key" in the data
        enableColumnFilter: false,
        id: "id", // id is used as a sort key (i.e., actual api name)
        enableSorting: false,
    },
    {
        Header: () => "Date",
        accessorKey: "flaggedDate", // accessor is the "key" in the data
        id: "flaggedDate", // id is used as a sort key (i.e., actual api name)
        enableSorting: false,
        enableColumnFilter: false,
        Cell: ({ data, value }) => {
            return format(new Date(value), LONG_DATE_FORMAT);
        },
    },
    {
        Header: () => "Project Id",
        accessorKey: "projectId", // accessor is the "key" in the data
        id: "projectId", // id is used as a sort key (i.e., actual api name)
        Cell: ({ data, value }) => {
            return <a href={`/project/${data.projectKey}/potential`}>{value}</a>;
        },
        enableSorting: false,
    },
    {
        Header: () => "Submitted By",
        accessorKey: "submitterDisplayName", // accessor is the "key" in the data
        id: "submitterDisplayName", // id is used as a sort key (i.e., actual api name)
        enableSorting: false,
        enableColumnFilter: false,
    },
    {
        Header: () => "Reason",
        accessorKey: "reason", // accessor is the "key" in the data
        id: "reason", // id is used as a sort key (i.e., actual api name)
        enableSorting: false,
        enableColumnFilter: false,
    },
    {
        Header: () => "User Feedback",
        accessorKey: "userFeedback", // accessor is the "key" in the data
        id: "userFeedback", // id is used as a sort key (i.e., actual api name)
        enableSorting: false,
        enableColumnFilter: false,
    },
    {
        Header: () => "Actions",
        accessorKey: "id", // accessor is the "key" in the data
        id: "id", // id is used as a sort key (i.e., actual api name)
        enableSorting: false,
        enableColumnFilter: false,
        Cell: () => {
            return (
                <div>
                    <button className="button -text">
                        <FontAwesomeIcon icon={faTrash} />
                    </button>
                </div>
            );
        },
    },
];

const debouncedFetchProjectFlags = debounce(fetchPotentialProjectFlags, 500);

const ProjectFlags = () => {
    const potentialProjectFlags = FlagsStore.useState((s) => s.potentialProjectFlags);
    const { page, setPage, limit, setLimit } = usePagination();
    const [totalPages, setTotalPages] = useState(1);
    const [projectId, setProjectId] = useState();
    const [sort, setSort] = useState({ id: "desc" });
    const [filters, setFilters] = useState([]);

    useEffect(() => {
        debouncedFetchProjectFlags(projectId, page, limit);
    }, [projectId, page, limit]);

    useEffect(() => {
        if (potentialProjectFlags && potentialProjectFlags.length > 0) {
            setTotalPages(Math.ceil(potentialProjectFlags[0].totalRecordCount / limit));
        }
    }, [potentialProjectFlags]);

    const manualSort = (s) => {
        setSort(s);
    };

    const handleSetFilters = (data) => {
        if (data?.projectId) {
            setProjectId(data?.projectId);
        } else {
            if (projectId !== "") setProjectId("");
        }
        setFilters(data);
    };

    return (
        <>
            <div>
                <h1>Project Flags</h1>
                <Table allowFilter={true} data={potentialProjectFlags} columns={flagColumns} hiddenColumns={[]} sort={sort} setSort={manualSort} setFilters={handleSetFilters} filters={filters} showPagination={false} />

                {/*<ConfirmButton
                                    onClick={() => {
                                        deletePotentialProjectFlag(flag.id).then(() => {
                                            debouncedFetchProjectFlags(projectId, page, limit);
                                        });
                                    }}
                                    text="Delete"
                                />*/}
                <Pagination
                    pageIndex={page}
                    pageCount={totalPages}
                    pageSize={limit}
                    setPageIndex={setPage}
                    setPerPage={setLimit}
                    canPreviousPage={page > 1}
                    canNextPage={page < totalPages - 1}
                    pageOptions={Array.from({ length: totalPages }, (x, i) => i)}
                />
            </div>
        </>
    );
};

export default ProjectFlags;
